
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";

const CircularGraphWithIcon = ({average,total}:any) => {

  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;

  ChartJS.register(ArcElement, Tooltip, Legend);

  const data = {
    datasets: [
      {
        data: [average, total],
        backgroundColor: ["#3baff6", "#e7e5db"],
        hoverBackgroundColor: ["#3baff6", "#BEB793"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: 50,
    maintainAspectRatio: false,
    z: 10,
    plugins: {
      tooltip: {
        displayColors:false,
        backgroundColor:'#fff',
        bodyColor:'#9b8f94',
        bodyFont:{
          size:16,
          
        },
        filter: function (tooltipItem: any) {

          return tooltipItem.parsed === 165;
        },
        callbacks: {

          beforeLabel:function(context: any){
            if (context.parsed===165) return `${access_code? "Employees":"Users"}`
            return undefined
          },
          label:function(context: any){
            if (context.parsed===165) return 'Engaging'
            return undefined
          },
          afterLabel:function(context: any){
            if (context.parsed===165) return '21.5%'
            return undefined
          },
        //   labelTextColor: function(context: { parsed: number; }) {

        //     if (context.parsed === 165) {
        //         return 'red';
        //     }
        //     return undefined;
        // },
         
        }
      },
      title: {
        display: true,
        text: "Doughnut Chart",
        color: "blue",

        responsive: true,
        animation: {
          animateScale: true,
        },
      },
    },
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="my-doughnut-chart-1">
          <Doughnut data={data} options={options} />
          <div
           className="icon-container"
          >
            <PeopleRoundedIcon style={{ fontSize: 30, color: "#e76943" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CircularGraphWithIcon;
